import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { cardBorderImg } from '@styles/common/Card';

export const CoupleSecWrapper = styled.div<{
  bgColor?: string;
}>`
  position: relative;
  margin: 0 auto;
  width: 572px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ bgColor }) =>
    bgColor ? bgColor : 'var(--backgroundColor)'};
  border-radius: var(--cardBorderRadius);
  overflow: hidden;

  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    ${cardBorderImg};
    pointer-events: none;
  }

  &:hover {
    .coupleInfo {
      &::before {
        width: 90px;
        height: 90px;
        top: calc(50% - 46px);
        left: calc(50% - 46px);
      }
    }
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const CoupleText = styled.h5`
  position: absolute;
  left: 50%;
  width: 300px;
  text-align: center;
  transform: translateX(-50%);
  word-break: keep-all;
`;

export const CoupleInfo = styled(motion.div)<{
  themeSet?: any;
}>`
  position: absolute;
  top: calc(50% - 30px);
  left: calc(50% - 30px);
  width: 60px;
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 36px;
  text-align: center;
  font-family: var(--headerFontFamily);
  z-index: 0;
  color: ${({ themeSet }) =>
    themeSet ? themeSet.textColor : 'var(--textColor)'};

  span {
    font-size: 16px;
  }

  &::before {
    content: '';
    position: absolute;
    top: calc(50% - 41px);
    left: calc(50% - 41px);
    width: 80px;
    height: 80px;
    border: 1px solid
      ${({ themeSet }) => themeSet?.subTextColor || 'var(--subTextColor)'};
    background-color: ${({ themeSet }) =>
      themeSet?.backgroundColor || 'var(--backgroundColor)'};
    transform: rotate(45deg);
    transition: all 0.2s;
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    top: calc(50% - 40px);
    left: calc(50% - 40px);
    /* background-color: var(--cardBackgroundColor); */
    background-color: ${({ themeSet }) =>
      themeSet?.subTextColor || 'var(--subTextColor)'};
    /* opacity: 0.2; */
    backdrop-filter: blur(8px);
    width: 80px;
    height: 80px;
    transform: rotate(45deg);
    transition: all 0.2s;
    transform-origin: 50% 50%;
    z-index: -1;
  }

  &:hover {
    cursor: var(--hoverCursorURL), pointer;

    &::after {
      width: 60px;
      height: 60px;
      top: calc(50% - 30px);
      left: calc(50% - 30px);
      /* opacity: 0.5; */
    }
  }
`;

const dirMap = {
  left: css`
    margin-bottom: 32px;
  `,
  right: css`
    margin-top: 32px;
  `,
};

export const ImgSec = styled(motion.div)<{
  imgURL?: string;
  dir: string;
}>`
  position: relative;
  max-width: 220px;
  width: 100%;
  height: 372px;
  transition: 0.2s;
  /* z-index: 0; */

  mask-image: linear-gradient(
    to ${({ dir }) => dir},
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 30%
  );

  background: top/cover no-repeat
    ${({ imgURL }) =>
      imgURL ? `url('${imgURL}')` : 'var(--cardBackgroundColor)'};

  @media (max-width: 480px) {
    max-width: 100%;
  }
`;

export const NameWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  max-width: 600px;
  width: 100%;
  height: 372px;
  z-index: 0;
`;

export const NameSec = styled.div`
  font-family: var(--headerFontFamily);
  font-weight: 600;
  font-size: 26px;
  position: absolute;
  word-break: keep-all;

  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  gap: 16px;

  @media (max-width: 480px) {
    font-size: 22px;
    max-width: 200px;
  }
`;

export const Dia = styled.div<{
  color: string;
}>`
  width: 8px;
  height: 8px;
  border: 1px solid ${({ color }) => color || 'var(--textColor)'};
  transform: rotate(45deg);
`;

export const Bar = styled.div`
  position: absolute;
  width: 500px;
  height: 1px;
  /* background-color: var(--subTextColor); */
`;

export const InfoDecoBar = styled.div<{
  color: string;
}>`
  position: absolute;
  width: 1px;
  height: 220px;
  top: calc(50% - 110px);
  left: 50%;
  /* background-color: var(--subTextColor); */
  z-index: -2;

  &::after {
    content: '';
    position: absolute;
    top: calc(50% - 5px);
    right: -70px;
    width: 8px;
    height: 8px;
    border: 1px solid ${({ color }) => color || 'var(--textColor)'};
    transform: rotate(45deg);
  }

  &::before {
    content: '';
    position: absolute;
    top: calc(50% - 5px);
    left: -70px;
    width: 8px;
    height: 8px;
    border: 1px solid ${({ color }) => color || 'var(--textColor)'};
    transform: rotate(45deg);
  }
`;

export const ButtonWrap = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  justify-content: center;
`;

export const CoupleItemWrapper = styled.div`
  position: relative;
  width: fit-content;
  margin: 0 auto;

  a {
    width: fit-content;
  }
  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const LockSec = styled.div`
  position: absolute;
  right: 24px;
  top: 16px;
`;
